import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(cep: string) {
    return wrapEndpoint(() =>
      client.GET('/cep/{cep}', {
        params: {
          path: {
            cep,
          },
        },
      }),
    )
  },
}
